import {ElMessage, ElMessageBox, ElNotification, ElLoading} from 'element-plus'


let loadingInstance

export default {
    //普通消息框
    msg(msg) {
        ElMessage.primary(msg)
    },
    msgError(msg) {
        ElMessage.error(msg)
    },
    msgSuccess(msg) {
        ElMessage.success(msg)
    },

    //弹窗消息
    alert(msg, type, title) {
        ElMessageBox.alert(
            msg,
            title || '系统提示',
            {
                confirmButtonText: '确认',
                type: type || 'primary',
                zIndex: 10000,
            })
    },

    //通知框  primary  success  info  warning  error
    notice(msg, type, title) {
        ElNotification({
            title: title || "系统提示",
            message: msg,
            duration: 3000,
            type: type || "info",
            offset: 80,
            zIndex: 10000,
        })
    },


    //加载框
    loading(msg) {
        loadingInstance = ElLoading.service({
            lock: true,
            text: msg,
            zIndex: 10000,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        })
    },

    closeLoading() {
        if (loadingInstance) {
            loadingInstance.close()
            loadingInstance = null
        }
    }


}